import { IBuilder } from './builder';
import { ISeller } from './seller';

export enum EPromoType {
  Bank = 'bank',
  Bonus = 'bonus',
  Discount = 'discount',
  MaternalCapital = 'maternalCapital',
  MilitaryMortgage = 'militaryMortgage',
  CianMortgage = 'cianMortgage',
  Mortgage = 'mortgage',
  Installment = 'installment',
}

export interface IPromo {
  authorLogoUrl?: string | null;
  authorName?: string | null;
  availableJks: IAvailableJk[];
  bank: IPromoBank | null;
  banks: IPromoBank[];
  companyId: number | null;
  description?: string;
  end?: string;
  features: IPromoFeature[];
  isBlackFriday: boolean;
  isFromBank: boolean;
  isFromBuilder: boolean;
  mortgageParams: IPromoMortgageParams | null;
  name: string;
  promoId: number;
  uniquePromoId: string;
  promoImage?: string;
  promoSource?: string;
  promoType: EPromoType;
  authorRealtyUserId?: number;
  start?: string;
  subtitle?: string;
  availablePurchaseTerms?: string[];
  dialogLabels: IPromoLabel[];
  promoLegalTerms?: string;
}

export interface IAvailableJk {
  id: number;
  link: string;
  name: string;
}

export interface IPromoBank {
  cianMortgagePartnerLink?: string;
  id: number;
  isPartner: boolean;
  logoUrl?: string;
  name: string;
  secondRoundImageUrl?: string;
  secondSquareImageUrl?: string;
}

export interface IPromoFeature {
  name: string;
  value: string;
  valueChange?: IPromoFeatureValueChange;
}

export interface IPromoFeatureValueChange {
  /** Диалоговое окно с описанием изменения значения **/
  dialog?: IValueChangeDialog;
  /** Новое значение **/
  newValue: string;
  /** Подзаголовок **/
  subtitle: string;
}

export interface IValueChangeDialog {
  /** Описание **/
  description: string;
  /** Ссылка на изображение **/
  imageUrl?: string;
  /** Заголовок **/
  title: string;
}

export interface IPromoMortgageParams {
  interestRate?: number | null;
  maxCredit?: number | null;
  maxLoanTerm?: number | null;
  minInitialPaymentRate?: number | null;
}

export interface IAvailableContacts {
  builders: IBuilder[];
  sellers: ISeller[];
}

export interface IPromoLabel {
  /** Текст **/
  text: string;
  /** Тип метки **/
  type: string;
}
